export default {
	data() {
		return { ranzcrProfileSpecialty: null };
	},
	computed: {
		shouldPrefillRanzcrSpecialty() {
			return this.ranzcrProfileSpecialty && this.form
				&& this.$formTools.getItemValue(this.form, 'Field226') === 'RANZCR - The Royal Australian and New Zealand College of Radiologists'
				&& this.$formTools.getItemValue(this.form, 'field_ranzcr_entry_type') === 'CPD Activity';
		},
	},
	watch: {
		shouldPrefillRanzcrSpecialty(shouldPrefill) {
			if (shouldPrefill) {
				this.$nextTick(() => {
					if (this.shouldPrefillRanzcrSpecialty && !this.$formTools.getItemValue(this.form, 'field_ranzcr_specialty')) {
						this.$formTools.setItemValue(this.form, 'field_ranzcr_specialty', this.getRanzcrDiarySpecialty());
					}
				});
			}
		},
	},
	methods: {
		getRanzcrDiarySpecialty() {
			return {
				'Clinical Radiology': 'Clinical Radiologists',
				'Radiation Oncology': 'Radiation Oncologists',
			}[this.ranzcrProfileSpecialty] || null;
		},
		initializeRanzcrDiary(form) {
			this.loadRanzcrProfileSpecialty();
			if (this.$route.query.ranzcrConversation === '1') {
				this.$formTools.setItemValue(form, 'Field226', 'RANZCR - The Royal Australian and New Zealand College of Radiologists');
				this.$formTools.setItemValue(form, 'field_ranzcr_entry_type', 'Structured Annual Conversation');
			}
		},
		loadRanzcrProfileSpecialty() {
			this.ranzcrProfileSpecialty = null;
			return Promise.all([
				this.$api.v2.get('personal-profile/additional-fields'),
				this.$api.v2.get('personal-profile/additional-fields/values'),
			]).then(([fields, values]) => {
				const group = fields.body.find(group => group.title === 'RANZCR - The Royal Australian and New Zealand College of Radiologists');
				const specialty = group?.fields.find(field => field.title === 'Specialty');
				if (specialty) {
					this.ranzcrProfileSpecialty = values.body.find(value => value.fieldId === specialty.fieldId)?.value || null;
				}
			}).catch(error => {
				this.$httpError('Failed to load RANZCR profile specialty', error);
			});
		},
	},
};
